export default "__VITE_ASSET__CRqtF8Ka__"